import React from 'react';
import { SERIF, IITH } from '@/pages/landing/iithBrand';

/** Compact KPI strip — dark (inside navy hero) or light (FIC content area). */
export default function RbacStatStrip({ items = [], tone = 'dark' }) {
  const light = tone === 'light';
  return (
    <div
      className={
        light
          ? 'grid grid-cols-2 sm:grid-cols-4 gap-3'
          : 'grid grid-cols-2 sm:grid-cols-4 gap-px bg-white/10 border-t border-white/10'
      }
      data-testid="rbac-stat-strip"
    >
      {items.map((s) => (
        <div
          key={s.label}
          className={light
            ? 'rounded-xl border border-[#D5DEE8] bg-white px-4 py-3 shadow-sm'
            : 'px-4 py-3 bg-white/5'}
        >
          <p className={`text-[10px] uppercase tracking-wider ${light ? 'text-zinc-500' : 'text-white/55'}`}>
            {s.label}
          </p>
          <p
            className={`text-xl font-semibold mt-0.5 tabular-nums ${light ? 'text-[#071B34]' : 'text-white'}`}
            style={{ fontFamily: SERIF }}
          >
            {s.value}
          </p>
          {s.hint ? (
            <p className={`text-[11px] mt-0.5 truncate ${light ? 'text-zinc-400' : 'text-white/45'}`}>
              {s.hint}
            </p>
          ) : null}
          {light ? (
            <div className="mt-2 h-0.5 rounded-full w-8" style={{ background: IITH.saffron }} />
          ) : null}
        </div>
      ))}
    </div>
  );
}
